import getUsers from './methods/getUsers';
import saveUsers from './methods/saveUsers';
import deleteUsers from './methods/deleteUsers';
import restoreUser from './methods/restoreUser';
import firebaseCheckAuth from './methods/firebaseCheckAuth';
import getUserAuthState from './methods/getUserAuthState';
import createUser from './methods/createUser';
import getManagerLinks from './methods/getManagerLinks';

const backendStorage = {
  getUsers,
  saveUsers,
  deleteUser: deleteUsers,
  deleteUsers,
  restoreUser,
  firebaseCheckAuth,
  getUserAuthState,
  createUser,
  getManagerLinks,
};

export default backendStorage;
